// Port of api/fuel/app/classes/insights/worth/designers.php

import Segment from 'offline/insights/segment'
import Constants from 'offline/constants'
import Util from 'offline/util'
import Designer from 'offline/model/designer'

function roundWorth(value) {
	return Math.round(parseFloat(value) || 0)
}

export default Segment.extend({
	name: 'designers',
	types: [Constants.TYPE_USER],
	insight: false,
	detail: ['designers'],
	run: function(type, owner, userIndex, detail, filter) {
		if (!owner.get_count_collection()) return {}

		var limit = detail ? 100 : 5
		var mode = (filter && filter.designers) ? filter.designers : 'total'
		var ranked = []

		var sorted = Util.queryFast(
			'SELECT GROUP_CONCAT(DISTINCT c.game_id ORDER BY c.game_id ASC) AS i,' +
			' COUNT(DISTINCT(c.game_id)) AS g, d.designer_id AS d,' +
			' ' + (mode === 'total' ? 'SUM' : 'AVG') + '(COALESCE(NULLIF(v.game_version_worth_value, 0), g.game_worth_value, 0)) AS w' +
			' FROM (collection c JOIN game g ON c.game_id = g.game_id)' +
			' LEFT JOIN game_version v ON v.game_version_id = c.game_version_id, game_designer d' +
			' WHERE d.game_id = c.game_id' +
			' AND c.user_id = ' + owner.get_id() +
			' AND c.collection_own = 1' +
			' AND g.game_worth_value > 0' +
			' AND g.game_type = ' + Constants.GAME_TYPE_BASE +
			' GROUP BY d.designer_id' +
			(mode === 'average' ? ' HAVING COUNT(DISTINCT(c.game_id)) > 1' : '') +
			' ORDER BY w DESC LIMIT 0, ' + limit
		)

		var index = []
		var grouped = {}
		var allGameIds = []

		for (var i = 0; i < sorted.length; i++) {
			var item = sorted[i]
			var designerId = parseInt(item.d, 10)
			var itemIndex = item.i ? item.i.split(',') : []
			grouped[designerId] = []
			index.push(designerId)

			for (var j = 0; j < itemIndex.length; j++) {
				var gameId = parseInt(itemIndex[j], 10)
				if (!gameId) continue
				grouped[designerId].push(gameId)
				allGameIds.push(gameId)
			}
		}

		// per-game worth lookup (deterministic — avoids the GROUP_CONCAT alignment
		// bug that arises when a user owns multiple versions of the same game).
		var worthByGameId = {}
		if (allGameIds.length) {
			var worthRows = Util.queryFast(
				'SELECT c.game_id AS gid,' +
				' MAX(COALESCE(NULLIF(v.game_version_worth_value, 0), g.game_worth_value, 0)) AS gw' +
				' FROM (collection c JOIN game g ON c.game_id = g.game_id)' +
				' LEFT JOIN game_version v ON v.game_version_id = c.game_version_id' +
				' WHERE c.user_id = ' + owner.get_id() +
				' AND c.collection_own = 1' +
				' AND g.game_worth_value > 0' +
				' AND g.game_type = ' + Constants.GAME_TYPE_BASE +
				' AND c.game_id IN(' + Util.in(allGameIds) + ')' +
				' GROUP BY c.game_id'
			)
			for (var wi = 0; wi < worthRows.length; wi++) {
				worthByGameId[worthRows[wi].gid] = worthRows[wi].gw
			}
		}

		if (index.length) {
			var details = Designer.indexed('designer_id', {
				where: [
					['designer_id', 'in', index]
				]
			})

			for (var k = 0; k < sorted.length; k++) {
				var entry = sorted[k]
				var id = parseInt(entry.d, 10)
				var gameWorths = []

				for (var g = 0; g < grouped[id].length; g++) {
					var currentGameId = grouped[id][g]
					gameWorths.push({
						id: currentGameId,
						worth: roundWorth(worthByGameId[currentGameId])
					})
				}

				gameWorths = gameWorths.slice().sort(function(a, b) { return a.worth !== b.worth ? b.worth - a.worth : a.id - b.id })

				for (var r = 0; r < 3 && r < gameWorths.length; r++) this._references.games.push(gameWorths[r].id)

				ranked.push({
					id: details[id] ? details[id].get_id() : id,
					name: details[id] ? details[id].get_name() : '',
					worth: roundWorth(entry.w),
					count: parseInt(entry.g, 10) || 0,
					games: gameWorths.slice(0, 3)
				})
			}
		}

		return {
			designers: ranked
		}
	}
})
